<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">{{ $i18n.t("schedule.title_edit") }}</h1>
    <form>
      <!-- 編集 -->
      <b-card class="w-100">
            <b-form-group
              id="codeForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_code')"
              label-for="input-horizontal"
            >
              <b-form-input disabled=true v-model="codeForm"></b-form-input>
            </b-form-group>
            <b-form-group
              id="lineListForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_line')"
              label-for="input-horizontal"
            >
              <b-form-select v-if="sFlag !== '0'" disabled=true v-model="lineListForm" :options="lineFormOptions" class="mb-3" ></b-form-select>
              <b-form-select v-if="sFlag === '0'" @change="changeLine" v-model="lineListForm" :options="lineFormOptions" class="mb-3" ></b-form-select>
            </b-form-group>
            <b-form-group
              id="moForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_mo')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
              <div class="flex-fill pr-3">
              <b-form-input v-model="moForm" disabled=true :placeholder="this.$i18n.t('schedule.placeholder_mo')"></b-form-input>
              </div>
              </div>
            </b-form-group>
            <b-form-group
              id="sCountForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_scount')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill pr-3">
                  <b-form-input v-model="sCountForm" :placeholder="this.$i18n.t('schedule.placeholder_scount')" maxlength="6"></b-form-input>
                </div>
                <div class="w-25">
                  <label>{{this.$i18n.t('schedule.label_planablenum')}} : {{remainCount}}</label>
                </div>
              </div>
            </b-form-group>
            <b-form-group
              id="dateForm"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('schedule.label_date')"
              label-for="input-horizontal"
            >
              <div class="d-flex align-items-center">
                <div class="flex-fill">
                  <b-form-input id="from" v-model="from" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="fromTime" v-model="fromTime" type="time"></b-form-input>
                </div>
                <div class="flex-shrink-1 px-2">-</div>
                <div class="flex-fill">
                  <b-form-input id="to" v-model="to" type="date"></b-form-input>
                </div>
                <div class="flex-fill">
                  <b-form-input id="toTime" v-model="toTime" type="time"></b-form-input>
                </div>
              </div>
            </b-form-group>
            <div>
              <b-button variant="primary" @click="back" class="float-left mr-20">{{ $i18n.t("schedule.button_back") }}</b-button>
            </div>
            <div>
              <b-button variant="primary" @click="delPlan" class="float-right mr-5"> {{ $i18n.t("schedule.button_delete") }} </b-button>
            </div>
            <div>
              <b-button variant="primary" @click="regist" class="float-right mr-5">{{ $i18n.t("schedule.button_update") }} </b-button>
            </div>
      </b-card>
    </form>
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('schedule.info_update')" :titleMsg="this.$i18n.t('schedule.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('schedule.info_delete')" :titleMsg="this.$i18n.t('schedule.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm2"/>
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  data () {
    return {
      codeForm: '',
      lineListForm: '',
      lineFormOptions: [{ value: '', text: this.$i18n.t('schedule.label_select') }],
      moForm: '',
      moSeqForm: '',
      sCountForm: '',
      from: '',
      to: '',
      fromTime: '',
      defFromTime: '',
      toTime: '',
      defToTime: '',
      sFlag: '',
      remainCount: '',
      hidCode: '',
      hidRev: '',
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      errMsg: '',
      errSbj: ''
    }
  },
  created () {
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.sFlag = this.$route.query.sFlag
    this.searchLine()

    // 値セット
    this.moForm = this.$route.query.mo
    this.moSeqForm = this.$route.query.moSeq
    this.codeForm = this.$route.query.code
    this.hidCode = this.$route.query.hidcode
    this.hidRev = this.$route.query.hidrev
    this.lineListForm = this.$route.query.line
    this.sCountForm = this.$route.query.scount

    // 残計画取得
    this.searchRemain()

    // 日時セット
    this.setDate()
  },
  methods: {
    setDate: function () {
      // 日時セット
      var start = this.$route.query.start
      var end = this.$route.query.end
      if (start.length === 14 && end.length === 14) {
        // パラメータをDate型に変換
        var fromdate = start.substr(0, 4) + '/' + start.substr(4, 2) + '/' + start.substr(6, 2)
        var fromtime = start.substr(8, 2) + ':' + start.substr(10, 2)
        var fromDate = new Date(fromdate + ' ' + fromtime)
        var todate = end.substr(0, 4) + '/' + end.substr(4, 2) + '/' + end.substr(6, 2)
        var totime = end.substr(8, 2) + ':' + end.substr(10, 2)
        var toDate = new Date(todate + ' ' + totime)
        // フォームに合わせてフォーマット
        this.from = window.formatDate(fromDate, 'yyyy-MM-dd')
        this.to = window.formatDate(toDate, 'yyyy-MM-dd')
        this.fromTime = window.formatDate(fromDate, 'HH:mm')
        this.defFromTime = this.fromTime
        this.toTime = window.formatDate(toDate, 'HH:mm')
        this.defToTime = this.toTime
      }
    },
    regist: function () {
      // 入力値チェック
      if (!this.isValid()) {
        return
      }
      var startDate = ''
      if (this.from !== '') {
        var from = ''
        if (this.fromTime !== '') {
          from = this.$moment(this.from + ' ' + this.fromTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          from = this.$moment(this.from + ' ' + this.defFromTime, 'YYYY-MM-DD HH:mm:00')
        }
      }
      var endDate = ''
      if (this.to !== '') {
        var to = ''
        if (this.toTime !== '') {
          to = this.$moment(this.to + ' ' + this.toTime, 'YYYY-MM-DD HH:mm:00')
        } else {
          to = this.$moment(this.to + ' ' + this.defToTime, 'YYYY-MM-DD HH:mm:00')
        }
      }
      // 日付論理チェック
      var cmpFrom = new Date(from)
      var cmpNow = new Date()
      var cmpTo = new Date(to)
      // 開始時刻が現在時刻より前でないか
      if (cmpNow.getTime() > cmpFrom.getTime()) {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_from_before_now')
        this.$bvModal.show('md-err')
        return
      }
      // 開始と終了が逆転していないか
      if (cmpFrom.getTime() > cmpTo.getTime()) {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_from_to_reverse')
        this.$bvModal.show('md-err')
        return
      }
      startDate = from.utc().format('YYYY-MM-DD HH:mm:ss')
      endDate = to.utc().format('YYYY-MM-DD HH:mm:ss')

      //  リクエスト先の型に合わせる
      var lineStr = String(this.lineListForm)
      var moSeqInt = parseInt(this.moSeqForm)
      var sCountInt = parseInt(this.sCountForm)

      // リクエスト
      var reqObj = {}
      reqObj.start = startDate
      reqObj.end = endDate
      reqObj.code = this.hidCode
      reqObj.rev = this.hidRev
      reqObj.line = lineStr
      reqObj.mo = this.moForm
      reqObj.mo_seq = moSeqInt
      reqObj.schedule_count = sCountInt

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/schedule/update', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    isValid: function () {
      // ライン
      if (this.lineListForm === null || this.lineListForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_line_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      // 計画数
      if (this.sCountForm === null || this.sCountForm === '') {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_schedule_count_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      if (!window.checkNum(this.sCountForm)) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_schedule_count_number')
        this.$bvModal.show('md-err')
        return false
      } else if (this.sCountForm <= 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('schedule.err_schedule_count_under_zero')
        this.$bvModal.show('md-err')
        return false
      }
      // 日時
      if (this.from === '' || this.to === '') {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_day_hissu')
        this.$bvModal.show('md-err')
        return false
      }
      return true
    },
    // ライン取得
    searchLine: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      var body = {}
      body.lineId = ''
      body.lineIdLikeFlg = ''
      body.lineName = ''
      body.base = ''
      body.lineKind = ''
      body.efFlg = '1'

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true

      this.$axios
        .post(window.END_POINT + '/master/line/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var lineInfoList = res.data.lineInfo
            var lines = []

            // 整形
            for (var i = 0; i < lineInfoList.length; i++) {
              var line = {}
              line.value = lineInfoList[i].line_id
              line.text = lineInfoList[i].line_name
              lines.push(line)
            }
            // 一旦データクリア
            this.lineFormOptions.splice(1)
            // データセット
            this.lineFormOptions.splice(1, 0, ...lines)
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    searchRemain: function () {
      // 入力チェック
      var line = ''
      var mo = ''
      // 型番
      if (this.codeForm === '') {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_code_hissu')
        this.$bvModal.show('md-err')
        return
      }
      // ライン
      if (this.lineListForm !== '') {
        line = String(this.lineListForm)
      } else {
        this.errSbj = this.$i18n.t('schedule.title')
        this.errMsg = this.$i18n.t('schedule.err_line_hissu')
        this.$bvModal.show('md-err')
        return
      }
      if (this.moForm !== '') {
        mo = this.moForm
      }

      var reqObj = {}
      reqObj.mo = mo
      reqObj.code = this.hidCode
      reqObj.rev = this.hidRev
      reqObj.line = line

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/schedule/selectNonSchedule', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else if (res.data.message === 'schedule.err_not_non_schedule') {
              // 残計画数が取得できなかった場合は0をセット
              this.remainCount = '0'
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 整形
            this.remainCount = res.data.nonScheduleInfo[0].non_schedule_count
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    delPlan: function () {
      //  リクエスト先の型に合わせる
      var moSeqInt = parseInt(this.moSeqForm)

      var reqObj = {}
      reqObj.mo = this.moForm
      reqObj.mo_seq = moSeqInt

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .delete(window.END_POINT + '/schedule/delete', {
          'headers': headers,
          'data': reqObj
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.$bvModal.show('md-confirm2')
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    // ラインプルダウン変更アクション
    changeLine: function () {
      // 残計画取得
      this.searchRemain()
    },
    back: function () {
      var searchFlg = 1
      var path = '/schedule'
      this.$router.push({ path: path, query: {searchFlg: [searchFlg]} })
    },
    registConfirm: function () {
      this.$bvModal.hide('md-confirm')
    },
    registConfirm2: function () {
      this.$bvModal.hide('md-confirm2')
      // 検索画面へ遷移
      this.back()
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  },
  routes: [
    {
      path: '/schedule/:searchFlg',
      name: 'schedule',
      components: './Schedule.vue'
    }
  ]
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ScheduleEdit.vue